import { uiConfig as commonUiConfig } from '@volumental/common';

export const uiConfig = {
  ...commonUiConfig,
};
